module.exports = __webpack_public_path__ + "media/images/android-chrome-512x512-483f4224c62fc2caf895fb73f4630e52.png";